import type { TFlagConfig } from "@/lib/feature-flags";
import { api } from "./api";

type TSaveFeatureFlagsResponse = {
  status: string;
  version: number;
  url: string;
};

export const featureFlagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    saveFeatureFlags: builder.mutation<TSaveFeatureFlagsResponse, TFlagConfig>({
      query: (config) => ({
        url: "/feature-flags",
        method: "POST",
        body: config,
      }),
    }),
    getFeatureFlags: builder.query<TFlagConfig, void>({
      query: () => ({ url: "/feature-flags", method: "GET" }),
    }),
  }),
  overrideExisting: false,
});

export const { useSaveFeatureFlagsMutation, useGetFeatureFlagsQuery } =
  featureFlagsApi;
